import { render, staticRenderFns } from "./InvitationToLogin.vue?vue&type=template&id=51888879&scoped=true&"
import script from "./InvitationToLogin.vue?vue&type=script&lang=js&"
export * from "./InvitationToLogin.vue?vue&type=script&lang=js&"
import style0 from "./InvitationToLogin.vue?vue&type=style&index=0&id=51888879&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51888879",
  null
  
)

export default component.exports